import React from "react";
import { PropTypes } from 'prop-types';
import InputComponent from "./InputComponent";
import SelectComponent from "./SelectComponent";
import { SelectComponentWrap } from "./Tabs/styles";
import { Row, Col } from "antd";
import { setSuccessorValues, jsonTemp, validationHandler,toggleStepTwoUpdateButton } from "../../actions";
import { connect } from "react-redux";
import { MainWrapper, ErrMargin } from "../styles";
import DatePickerComponent from "./DatePicker";
import { basicImports, basicLegacy } from "../../DefaultPropTypes";
import { CommonInfoDerivedStates, SuccessorInfoStates } from "../../selectors";

export const handleFocusIn = (props, e, type, successors) => {
  let arr = successors;
  if (arr.length > 0) {
    arr.forEach(val => {
      if (type.toLowerCase().includes("relation")) {
        val.relationshipType = undefined;
      } else if (type.toLowerCase().includes("title")) {
        val.title = undefined;
      } else if (type.toLowerCase().includes("suffix")) {
        val.suffix = undefined;
      } else if (type.toLowerCase().includes("gender")) {
        val.gender = undefined;
      }
    });
  }
  if (props.isStep2Edit) {
    let tempData = props.tempData.tempJSON;
    if (props.contentKey == 1 || props.contentKey == 2) {
      tempData.legacyOptions[props.contentKey - 1].successorAdvisor = arr;
    } else {
      tempData.legacyOptions[
        props.contentKey - 1
      ].successionPlanGranteeOrg = arr;
    }
    props.jsonTemp({
      tempJSON: tempData
    });
  } else {
    props.setSuccessorValues({
      successorAdvisor: arr,
      key: props.contentKey,
      successorKey: props.successorKey - 1
    });
  }
};

export const handleBlur = (props, e, type, successors) => {
  let arr = successors;
  if (arr.length > 0) {
    arr.forEach(val => {
      if (val.key == props.successorKey) {
        if (type.toLowerCase().includes("first")) {
          if (val.firstName == "") {
            val.firstNameError = (
              <ErrMargin>Please enter first name</ErrMargin>
            );
          } else if (val.firstName != "" && val.firstName.length < 2) {
            val.firstNameError = (
              <ErrMargin>First name is too short</ErrMargin>
            );
          } else {
            val.firstNameError = null;
          }
        } else if (type.toLowerCase().includes("last")) {
          if (val.lastName == "") {
            val.lastNameError = <ErrMargin>Please enter last name</ErrMargin>;
          } else if (val.lastName != "" && val.lastName.length < 2) {
            val.lastNameError = <ErrMargin>Last name is too short</ErrMargin>;
          } else {
            val.lastNameError = null;
          }
        } else if (type.toLowerCase().includes("relation")) {
          if (
            val.relationshipType == "" ||
            val.relationshipType == undefined
          ) {
            val.relationshipTypeError = (
              <ErrMargin>Please enter your relation to account advisor</ErrMargin>
            );
          } else {
            val.relationshipTypeError = null;
          }
        } else if (type.toLowerCase().includes("dob")) {
          if (!val.dob) {
            val.dobError = (
              <ErrMargin>Please enter the date of birth</ErrMargin>
            );
          } else {
            val.dobError = null;
          }
        } else if (type.toLowerCase().includes("gender")) {
          if (val.gender == "" || val.gender == undefined) {
            val.genderError = <ErrMargin>Please select gender.</ErrMargin>;
          } else {
            val.genderError = null;
          }
        }
      }
    });
  }
  if (props.isStep2Edit) {
    let tempData = props.tempData.tempJSON;
    if (props.contentKey == 1 || props.contentKey == 2) {
      tempData.legacyOptions[props.contentKey - 1].successorAdvisor = arr;
    } else {
      tempData.legacyOptions[
        props.contentKey - 1
      ].successionPlanGranteeOrg = arr;
    }
    props.jsonTemp({
      tempJSON: tempData
    });
  } else {
    props.setSuccessorValues({
      successorAdvisor: arr,
      key: props.contentKey,
      successorKey: props.successorKey - 1
    });
  }
};

export const handleChange = (props, e, type, successors) => {
  if(props.stepperUpdateIndex.status){
    props.toggleStepTwoUpdateButton(true);
  }
  let arr = successors;
  if (arr.length > 0) {
    arr.forEach(val => {
      if (val.key == props.successorKey) {
        if (type.toLowerCase().includes("first")) {
          if (e.target.value.length > 0) {
            val.firstNameError = null;
          }

          let reg = /^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]{0,150}$/;
          if (reg.test(e.target.value)) {
            val.firstName = e.target.value;
          }
        } else if (type.toLowerCase().includes("last")) {
          if (e.target.value.length > 0) {
            val.lastNameError = null;
          }
          let reg = /^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]{0,150}$/;
          if (reg.test(e.target.value)) {
            val.lastName = e.target.value;
          }
        } else if (type.toLowerCase().includes("middle")) {
          val.middleName = e.target.value;
        } else if (type.toLowerCase().includes("title")) {
          val.title = e;
        } else if (type.toLowerCase().includes("suffix")) {
          val.suffix = e;
        } else if (type.toLowerCase().includes("gender")) {
          if (e.length > 0) {
            val.genderError = null;
          }
          val.gender = e;
        } else if (type.toLowerCase().includes("relation")) {
          if (e.length > 0) {
            val.relationshipTypeError = null;
          }
          val.relationshipType = e;
        } else if (type.toLowerCase().includes("dob")) {            
          if (e) {
            val.dobError = null;
          }
          val.dob = e;
        }
      }
    });      
  }
  if (props.isStep2Edit) {
    let tempData = props.tempData.tempJSON;
    if (props.contentKey == 1 || props.contentKey == 2) {
      tempData.legacyOptions[props.contentKey - 1].successorAdvisor = arr;
    } else {
      tempData.legacyOptions[
        props.contentKey - 1
      ].successionPlanGranteeOrg = arr;
    }
    props.jsonTemp({
      tempJSON: tempData,
      enableReset: true
    });
  } else {
    props.setSuccessorValues({
      successorAdvisor: arr,
      key: props.contentKey,
      successorKey: props.successorKey - 1
    });
  }    
};

export const SuccessorInfo = props => {
  let successors;
  if (props.isStep2Edit) {
    if (props.contentKey == 1 || props.contentKey == 2) {
      successors =
        props.tempData.tempJSON.legacyOptions[props.contentKey - 1]
          .successorAdvisor;
    } else {
      successors =
        props.tempData.tempJSON.legacyOptions[props.contentKey - 1]
          .successionPlanGranteeOrg;
    }
  } else {
    successors =
      props.legacy.legacyOptions[props.contentKey - 1].successorAdvisor
        .successorAdvisor;
  } 
  return (
    <MainWrapper>
      <Row>
        <Col lg={{ span: 10, offset: 0 }} md={{ span: 10 }}>
          <SelectComponentWrap>
            <SelectComponent
              handleFocusIn={e => handleFocusIn(props, e, "Title", successors)}
              id={`title${props.successorKey}${props.contentKey}`}
              title="Title (Optional)"
              placeholder=""
              data-test="title"
              data={props.titleDropDown}
              showArrow={true}
              handleInputChange={e => handleChange(props, e, "Title", successors)}
              value={successors[props.successorKey - 1].title}
            />
          </SelectComponentWrap>
        </Col>
        <Col lg={{ span: 10, offset: 1 }} md={{ span: 10 }}>
          <InputComponent
            handleBlur={e => handleBlur(props, e, "First Name", successors)}
            id={`fname${props.successorKey}${props.contentKey}`} 
            title="First Name"
            data-test="first-name"
            placeholder="Enter first name"
            handleInputChange={e => handleChange(props, e, "First Name", successors)}
            value={successors[props.successorKey - 1].firstName}
            max={150}
          />
          {successors[props.successorKey - 1].firstNameError
            ? successors[props.successorKey - 1].firstNameError
            : null}
        </Col>
      </Row>

      <Row>
        <Col lg={{ span: 10, offset: 0 }} md={{ span: 10 }}>
          <InputComponent
            title="Middle Name (Optional)"
            id={`middlename${props.successorKey}${props.contentKey}`} 
            placeholder="Enter middle name"
            data-test="middle-name"
            handleInputChange={e => handleChange(props, e, "Middle Name", successors)}
            value={successors[props.successorKey - 1].middleName}
            max={150}
          />
        </Col>
        <Col lg={{ span: 10, offset: 1 }} md={{ span: 10 }}>
          <InputComponent
            title="Last Name"
            id={`lastname${props.successorKey}${props.contentKey}`}
            placeholder="Enter last name"
            data-test="last-name"
            handleBlur={e => handleBlur(props, e, "Last Name", successors)}
            handleInputChange={e => handleChange(props, e, "Last Name", successors)}
            value={successors[props.successorKey - 1].lastName}
            max={150}
          />
          {successors[props.successorKey - 1].lastNameError
            ? successors[props.successorKey - 1].lastNameError
            : null}
        </Col>
      </Row>

      <Row>
        
        <Col lg={{ span: 10, offset: 0 }} md={{ span: 10 }}>
          <SelectComponentWrap>
            <SelectComponent
              handleFocusIn={e => handleFocusIn(props, e, "Suffix", successors)}
              id={`suffix${props.successorKey}${props.contentKey}`}
              title="Suffix (Optional)"
              placeholder=""
              data-test="suffix"
              data={props.suffixDropDown}
              showArrow={true}
              handleInputChange={e => handleChange(props, e, "Suffix", successors)}
              value={successors[props.successorKey - 1].suffix}
            />
          </SelectComponentWrap>
        </Col>
        <Col lg={{ span: 10, offset: 1 }} md={{ span: 10 }}>
          <SelectComponentWrap>
            <SelectComponent
              handleFocusIn={e => handleFocusIn(props, e, "relation", successors)}
              handleBlur={e => handleBlur(props, e, "relation", successors)}
              id={`relation${props.successorKey}${props.contentKey}`}
              title="Relation"
              data-test="relation"
              placeholder="-Select-"
              data={props.relationshipDropDown}
              showArrow={true}
              handleInputChange={e => handleChange(props, e, "relation", successors)}
              value={successors[props.successorKey - 1].relationshipType}
            />
          </SelectComponentWrap>
          {successors[props.successorKey - 1].relationshipTypeError
            ? successors[props.successorKey - 1].relationshipTypeError
            : null}
        </Col>
      </Row>

      <Row>
        <Col lg={{ span: 10, offset: 0 }} md={{ span: 10 }}>
          <DatePickerComponent
            id={`successorDob${props.successorKey}${props.contentKey}`}
            title="Date of Birth"
            data-test="date-of-birth"
            placeholder="Select date"
            handleInputChange={e => handleChange(props, e, "dob", successors)}
            value={successors[props.successorKey - 1].dob}
            handleBlur={e => handleBlur(props, e, "dob", successors)}
          />
          {successors[props.successorKey - 1].dobError
            ? successors[props.successorKey - 1].dobError
            : null}
        </Col>
        <Col lg={{ span: 10, offset: 1 }} md={{ span: 10 }}>
          <SelectComponentWrap>
            <SelectComponent
              handleFocusIn={e => handleFocusIn(props, e, "gender", successors)}
              handleBlur={e => handleBlur(props, e, "gender", successors)}
              id={`gender${props.successorKey}${props.contentKey}`}
              title="Gender"
              data-test="gender"
              placeholder="- Select -"
              data={props.genderDropDown}
              showArrow={true}
              handleInputChange={e => handleChange(props, e, "Gender", successors)}
              value={
                successors[props.successorKey - 1].gender != ""
                  ? successors[props.successorKey - 1].gender
                  : undefined
              }
            />
          </SelectComponentWrap>
          {successors[props.successorKey - 1].genderError
            ? successors[props.successorKey - 1].genderError
            : null}
        </Col>
      </Row>
    </MainWrapper>
  );
};

const mapStateToProps = state => ({
  legacy: state.getIn(["npaFormReducer", "legacyOptions", "legacyOptions"]),
  ...SuccessorInfoStates(state.toJS()),
  ...CommonInfoDerivedStates(state.toJS())
});

export const mapDispatchToProps = dispatch => ({
  setSuccessorValues: val => dispatch(setSuccessorValues(val)),
  jsonTemp: val => dispatch(jsonTemp(val)),
  validationHandler: val => dispatch(validationHandler(val)),
  toggleStepTwoUpdateButton: val => dispatch(toggleStepTwoUpdateButton(val))
});

SuccessorInfo.propTypes = {
  contentKey: PropTypes.number,
  genderDropDown:  basicImports,
  isStep2Edit: PropTypes.any,
  jsonTemp: PropTypes.func,
  legacy: PropTypes.shape({
    legacyOptions: basicLegacy
  }),
  relationshipDropDown: basicImports,
  setSuccessorValues: PropTypes.func,
  stepperUpdateIndex: PropTypes.any,
  successorKey: PropTypes.string,
  suffixDropDown: basicImports,
  tempData: PropTypes.any,
  titleDropDown: basicImports,
  toggleStepTwoUpdateButton: PropTypes.func,
  validationHandler: PropTypes.func,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SuccessorInfo);
